import CardCarousel from "components/CardCarousel"
import richText from "utilities/richText"
import cn from "classnames"

export default function FeaturedCaseWins({ blok }) {
  return (
    <section className={`bg-${blok.background} bg-cover px-5 py-8 lg:py-16`}>
      <div className="max-w-screen-xl mx-auto">
        <div
          className={cn({
            "text-primary": blok.background === "highlight-tint",
            "text-white": blok.background === "primary" || blok.background === "blueWaveOverlay",
          })}
        >
          {blok.eyebrow ? (
            <div className="uppercase py-2 flex justify-center">
              <span
                className={cn("eyebrow", {
                  "text-primary": blok.background === "highlight-tint",
                  "text-white": blok.background === "primary",
                })}
              >
                {blok.eyebrow}
              </span>
            </div>
          ) : null}
          <h2 className="text-center">{blok.heading}</h2>
          <div className="flex flex-col lg:flex-row lg:gap-10 lg:justify-between lg:my-4">
            <div className="py-2 lg:basis-1/2">{richText(blok.content)[0]}</div>
            <div className="py-2 lg:basis-1/2">{richText(blok.content)[1]}</div>
          </div>
          {richText(blok.content)[2] ? (
            <div className="lg:flex lg:justify-center">{richText(blok.content)[2]}</div>
          ) : null}
        </div>
        <CardCarousel cards={blok.cards} cardNumber={blok.card_number} cardSource="case-wins" className="text-black" />
      </div>
    </section>
  )
}
